import React from 'react';
import PropTypes from 'prop-types';

import pure from '../../lib/pure';

function entityTypeIconName(type) {
  switch (type.toLowerCase()) {
    case 'contact':
      return 'fa-user';

    case 'resource':
      return 'fa-user';

    case 'user':
      return 'fa-user';

    case 'customer':
      return 'fa-briefcase';

    case 'geocode':
      return 'fa-map-marker';

    default:
      return '';
  }
}


function EntityIcon({ type, className }) {
  return <i className={`fa ${entityTypeIconName(type)} ${className}`} />;
}

EntityIcon.defaultProps = {
  className: 'fa-fw',
};

EntityIcon.propTypes = {
  type: PropTypes.string.isRequired, // eslint-disable-line,
  className: PropTypes.string,
};

export default pure(EntityIcon);
